import React, { useCallback } from "react";
import { PiUserCircle } from "react-icons/pi";

import useCustomerProfileStore from "../../../../stores/customerProfileStore";
import useNavigationStore from "../../../../stores/navigationStore";

function AvatarButton() {
  const avatarImg = useCustomerProfileStore((s) => s.avatarDataUri);

  const handleClick = useCallback(() => {
    useNavigationStore.getState().setOpenSidebar(true);
  }, []);
  let avatar;

  if (avatarImg) {
    avatar = <img src={avatarImg} alt="Avatar" className="rounded-circle" />;
  } else {
    avatar = <PiUserCircle size={60} />;
  }

  return (
    <button onClick={handleClick} type="button" className="btn p-0 rounded-circle navbar-avatar-btn">
      {avatar}
    </button>
  );
}

export default AvatarButton;
